import { EventEmitter, Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { CodeReviewCommentModel } from '../Models/code-review-comment-model';
import { CodeReviewModel } from '../Models/code-review-model';

@Injectable({
  providedIn: 'root'
})
export class CodeReviewService {

  updateCodeReviewModel = new EventEmitter<void>();

  constructor(private rest: RestService) { }

  triggerCodeReviewModelUpdate() {
    this.updateCodeReviewModel.emit();
  }

  public getCodeReviewsByProjectId(projectId:String, requestData: any): any {;
    return this.rest.post("getCodeReviewsByProjectId", requestData, projectId);
  }

  public getCodeReviewById(codeReviewId: string): any {
    return this.rest.get("getCodeReviewById", codeReviewId);
  }

  public getCodeReviewConversationAndAssignedReviewersById(codeReviewId: string): any {
    return this.rest.get("getCodeReviewConversationAndAssignedReviewersById", codeReviewId);
  }

  public getReportByCodeReviewId(codeReviewId: string): any {
    return this.rest.get("getReportByCodeReviewId", codeReviewId);
  }

  public getCodeReviewByArtifactId(artifactId: string): any {
    return this.rest.get("getCodeReviewByArtifactId", artifactId);
  }

  public getCodeReviewIdByArtifactId(artifactId: string): any {
    return this.rest.get("getCodeReviewIdByArtifactId", artifactId);
  }

  public getCodeReviewTechnicalDetailsDataByReviewId(codeReviewId: string): any {
    return this.rest.get("getCodeReviewTechnicalDetailsDataByReviewId", codeReviewId);
  }

  public addCodeReviewForArtifact(codeReviewModel: CodeReviewModel, codeReviewCommentModel: CodeReviewCommentModel): any {
    let requestData = {
      codeReviewModel: codeReviewModel,
      codeReviewCommentModel: codeReviewCommentModel
    };
    return this.rest.post("addCodeReviewForArtifact", requestData);
  }

  public updateCodeReviewersByCodeReviewId(codeReviewers: any, codeReviewId: String): any {
    return this.rest.put("updateCodeReviewersByCodeReviewId", codeReviewers, codeReviewId);
  }

  public setCodeReviewReportByCodeReviewId(reportId: string, codeReviewId: String): any {
    return this.rest.put("setCodeReviewReportByCodeReviewId", reportId, codeReviewId);
  }

  public addNormalCommentByCodeReviewId(comment: string, codeReviewId: String): any {
    return this.rest.post("addNormalCommentByCodeReviewId", comment, codeReviewId);
  }

  public addReviewCommentByCodeReviewId(codeReviewCommentModel: CodeReviewCommentModel, codeReviewId: String): any {
    return this.rest.post("addReviewCommentByCodeReviewId", codeReviewCommentModel, codeReviewId);
  }

  public addAiFeedbackByTechnicalDetailsData(codeReviewCommentModel: CodeReviewCommentModel, codeReviewId: String): any {
    return this.rest.post("addAiFeedbackByTechnicalDetailsData", codeReviewCommentModel, codeReviewId);
  }

  public addReviewCommentReplyByCommentId(comment: string, commentId: String): any {
    return this.rest.post("addReviewCommentReplyByCommentId", comment, commentId);
  }

  public updateCommentByCommentId(comment: string, commentId: String): any {
    return this.rest.put("updateCommentByCommentId", comment, commentId);
  }

  public requestReReviewByCommentId(reviewer: string, commentId: String): any {
    return this.rest.put("requestReReviewByCommentId", reviewer, commentId);
  }

  public approveCodeReviewByCodeReviewId(codeReviewId: string): any {
    return this.rest.put("approveCodeReviewByCodeReviewId", null, codeReviewId);
  }

  public requestForChangesByCodeReviewId(codeReviewId: string): any {
    return this.rest.put("requestForChangesByCodeReviewId", null, codeReviewId);
  }

  public reOpenCodeReviewByCodeReviewId(codeReviewId: string): any {
    return this.rest.put("reOpenCodeReviewByCodeReviewId", null, codeReviewId);
  }

  public closeCodeReviewByCodeReviewId(codeReviewId: string): any {
    return this.rest.put("closeCodeReviewByCodeReviewId", null, codeReviewId);
  }

  public mergeCodeReviewByCodeReviewId(codeReviewId: string): any {
    return this.rest.put("mergeCodeReviewByCodeReviewId", null, codeReviewId);
  }

  public deleteCommentByCommentId(commentId: String, codeReviewId: string): any {
    return this.rest.delete("deleteCommentByCommentId", commentId, codeReviewId);
  }

  public deleteCommentReplyByCommentReplyId(commentReplyId: String, parentCommentId: string): any {
    return this.rest.delete("deleteCommentReplyByCommentReplyId", commentReplyId, parentCommentId);
  }

  public updateConversationResolutionByCommentId(resolution: boolean, commentId: String): any {
    return this.rest.put("updateConversationResolutionByCommentId", resolution, commentId);
  }
}
